<script lang="ts">
    import type {Rec} from 'typings/portaro.be.types';
    import {getLocalization, getServerUrl} from 'core/svelte-context/context';
    import KpClickCopyButton from 'shared/components/kp-click-copy-button/KpClickCopyButton.svelte';

    export let record: Rec;

    const localize = getLocalization();
    const serverUrl = getServerUrl();

    $: permalink = `${serverUrl}/records/${record.id}`;
</script>

<div class="permalink-container">
    <label for="permalink-{record.id}">{localize(/* @kp-localization detail.permantentniLink */ 'detail.permantentniLink')}:</label>
    <KpClickCopyButton buttonId="permalink-{record.id}">{permalink}</KpClickCopyButton>
</div>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .permalink-container {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: @padding-xs-horizontal;

        label {
            margin-bottom: 0;
        }
    }
</style>